export default __webpack_public_path__ + "static/media/roof.146ad809.jpeg";